/**
 * 해당 월에서 토·일과 공휴일을 뺀 일수.
 * 공휴일이 주말과 겹치면 그 날은 한 번만 빠진다.
 */
export function countMonthBusinessDays(
  year: number,
  month: number,
  holidayDates: Iterable<string> = []
): number {
  const y = Number(year);
  const m = Number(month);
  if (!Number.isInteger(y) || !Number.isInteger(m) || m < 1 || m > 12) return 0;

  const holidays = new Set<string>();
  for (const raw of holidayDates) {
    const key = String(raw || '').substring(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(key)) holidays.add(key);
  }

  const lastDay = new Date(y, m, 0).getDate();
  const mm = String(m).padStart(2, '0');
  let count = 0;
  for (let day = 1; day <= lastDay; day++) {
    const dow = new Date(y, m - 1, day).getDay();
    if (dow === 0 || dow === 6) continue;
    const key = `${y}-${mm}-${String(day).padStart(2, '0')}`;
    if (holidays.has(key)) continue;
    count += 1;
  }
  return count;
}
